import { Observable } from "rxjs";
import { retry } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { HttpInterface, } from "./http.interface";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "environments/environment";

@Injectable()
export class HttpService implements HttpInterface {

  //#region Constructor

  constructor(private _http: HttpClient) {
  }

  //#endregion

  //#region Methods

  getBaseUrl(): string {
    return '';
  }

  post<T>(url: string, data: any): Observable<T> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.apiBaseUrl.concat(url);
    return this._http.post<T>(url, data, { withCredentials: true }).pipe(retry(2));
  }

  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.apiBaseUrl.concat(url);
    return this._http.get<T>(url, { params: params, headers: headers, withCredentials: true });
  }

  getPos<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
    if (!url) {
      throw "url is empty";
    }

    url = environment.posapiurl.concat(url);

    return this._http.get<T>(url, {
      params,
      headers,
      withCredentials: true
    });
  }

  /**
   * Get file request
   * @param url
   * @param params
   * @param headers
   */
  getFile(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<Blob> {
    if (!url) {
      throw "url is empty";
    }
    url = environment.apiBaseUrl.concat(url);
    return this._http.get(url, { params: params, headers: headers, withCredentials: true, responseType: 'blob' }).pipe(retry(2));
  }

  delete<T>(url: string, id: number): Observable<T> {
    if (!url) {
      throw 'url is empty';
    }
    const options = {
      params: { id: id.toString() },
      withCredentials: true
    };
    url = environment.apiBaseUrl.concat(url);
    return this._http.delete<T>(url, options).pipe(retry(2));
  }



  //#endregion

}
